import {uniqBy} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {useLocalize} from '../../../../srcCommon/internationalization/internationalizationContext';
import {EditorErrorsEnum, getEditorErrorLabel} from '../../editors/commons/editorErrors';
import {EditorStateErrorMap} from './state/ruleEditorState';

/*
 * Props.
 */

interface RuleEditorErrorListProps {
  editorErrors: ReadonlyArray<EditorErrorsEnum>;
  stateErrors?: EditorStateErrorMap;
}

/*
 * Styles.
 */

const StyledWarningListUl = styled.ul`
  padding-left: 21px;
  margin: 8px 8px 8px 0;
`;

const StyledWarningListItemLi = styled.li`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

/*
 * Component.
 */

export const RuleEditorErrorList: FC<RuleEditorErrorListProps> = (props) => {
  const {editorErrors, stateErrors} = props;
  const localize = useLocalize();

  const uniqueErrors = stateErrors ? uniqBy(Object.entries(stateErrors), (entry) => entry[1]) : undefined;

  return (
    <StyledWarningListUl>
      {uniqueErrors
        ? uniqueErrors.map(([clientId, cardError]) => (
            <StyledWarningListItemLi key={clientId}>
              {localize(getEditorErrorLabel(cardError))}
            </StyledWarningListItemLi>
          ))
        : undefined}
      {editorErrors.map((error) => (
        <StyledWarningListItemLi key={error}>{localize(getEditorErrorLabel(error))}</StyledWarningListItemLi>
      ))}
    </StyledWarningListUl>
  );
};
